module.exports = __webpack_public_path__ + "img/4.a186e89a.jpg";